import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import de from "vuetify/src/locale/de";
import en from "vuetify/src/locale/en";
import es from "vuetify/src/locale/es";
import it from "vuetify/src/locale/it";

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: "fa",
    },
    theme: {
        themes: {
            dark: {
                primary: "#e84e0f",
            },
            light: {
                primary: "#e84e0f",
            },
        },
    },
    lang: {
        locales: { de, en, es, it },
        current: "en",
    },
});
